import { useEffect } from "react";
import { getCookie } from "../../utils/api";

const TawkToChat = () => {
  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const updateVisitorInfo = () => {
      window.Tawk_API.onLoad = function () {
        window.Tawk_API.setAttributes(
          {
            name: getCookie("firstName"),
            email: getCookie("loginEmail"),
          },
          function (error) {
            if (error) {
              console.error("Error setting Tawk.to visitor:", error);
            }
          }
        );
      };
    };

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/679ad9ca825083258e0d4cc8/1iiqe5g2r";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    script.onload = updateVisitorInfo;
    document.head.appendChild(script);

    const cookieCheckInterval = setInterval(() => {
      if (window.Tawk_API?.setAttributes) {
        window.Tawk_API.setAttributes({
          name: getCookie("firstName"),
          email: getCookie("loginEmail"),
        });
      }
    }, 5000);

    return () => {
      document.head.removeChild(script);
      clearInterval(cookieCheckInterval);
    };
  }, []);

  return null;
};

export default TawkToChat;
